import { Controller } from "@hotwired/stimulus"

// Toggles a value picker between a column reference and a constant. The kind
// <select> (data-value-kind-kind) shows the matching input (each carries
// data-kind); switching submits the parent mapping form so the value's args
// persist and the preview re-runs. Shared by the arithmetic-step and
// cond-branch sub-forms.
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.toggle()
  }

  toggle() {
    const kind = this.kindValue
    this.inputTargets.forEach((el) => {
      el.hidden = el.dataset.kind !== kind
    })
  }

  get kindValue() {
    const select = this.element.querySelector("[data-value-kind-kind]")
    return select ? select.value : "column"
  }
}
